<template>
	
	<div>
		
		<layout>

			<template v-slot:title> 
				CONFIGURACIÓN GENERAL
			</template>

			<template v-slot:subtitle> 
				CONFIGURACIÓN GENERAL
			</template>

			<template v-slot:content>

				<v-container id="gnral-setting">


					<v-row class="mt-4 mb-4">
						<v-col offset-lg="1" lg="10">

							<form @submit.prevent="update()">
								
								<v-card light class="pa-5" elevation="3">

									<v-textarea
					          filled
					          label="¿Quienes somos?"
					          v-model="setting.about"
					          required
					        ></v-textarea>

					        <v-textarea
					          filled
					          label="¿Porqué nosotros?"
					          v-model="setting.porque_nosotros"
					          required
					        ></v-textarea>

					        <v-text-field
							      label="Correo de contacto"
							      v-model="setting.email" 
							      filled
							      light
							      required
							    ></v-text-field> 

							    <v-text-field
							    	type="number"
							      label="Teléfono"
							      v-model="setting.phone" 
							      filled
							      light
							      required
							      minlength="10"
							      maxlength="10"
							    ></v-text-field> 

							    <v-text-field
							      label="Facebook"
							      v-model="setting.facebook" 
							      filled
							      light
							      required
							    ></v-text-field> 

							    <v-text-field
							      label="Instagram"
							      v-model="setting.instagram" 
							      filled
							      light
							      required
							    ></v-text-field> 

		      	      <v-btn dark large block type="submit">
		      		      Actualizar
		      		    </v-btn>

								</v-card>

							</form>

						</v-col>
					</v-row>
				</v-container>

			</template>

		</layout>
		

	</div>

</template>


<script>
	
	import Layout from './../../layout/Layout'
	import SettingService from '@/shared/services/SettingService'


	export default 
	{
		
		data() {
			return {
				setting: {
					about: null,
					porque_nosotros: null,
					email: null,
					phone: null,
					facebook: null,
					instagram: null
				}
			}
		},

		components: {
			Layout
		},

		created() {
			this.getSetting();
		},

		methods: {

			async getSetting()
			{
				const resp = await SettingService.get()

				this.setting.about = resp.data.about
				this.setting.porque_nosotros = resp.data.porque_nosotros
				this.setting.email = resp.data.email
				this.setting.phone = resp.data.phone
				this.setting.facebook = resp.data.facebook
				this.setting.instagram = resp.data.instagram
			},

			async update()
			{
    		const resp = await SettingService.update(this.setting)

    		if(resp.data == 'OK')
    			SwalAlert('', 'Datos actualizados', 'success')
    		else
    			SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo')
			}

		}

	}

</script>